import { render } from "./RallyRoadbookI18n.vue?vue&type=template&id=d8dbfed8"
import script from "./RallyRoadbookI18n.vue?vue&type=script&lang=js"
export * from "./RallyRoadbookI18n.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__